import { getPrograma, update } from "../index";
import { Interesados as Subs } from '../../../Suscripciones';
import { getParticipantes } from "../../../Context/Participante";
export default function Interesados() {
    const l = getParticipantes();
    const p = getPrograma();
    const i = p.interesados.filter(e => l.some(p => p.id === e.id));
    return <Subs i={i} url={`programa/${p.id}`} u={update} />
}